import { Link } from "react-router-dom";

var Modal = require("components/utility/AltModal");
var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var ProgressBar = require("components/utility/ProgressBar");

var OnboardingStageGenericGradeLevel = require("components/users/teachers/onboarding/OnboardingStageGenericGradeLevel");
var OnboardingStageSelectStandards = require("components/users/teachers/onboarding/OnboardingStageSelectStandards");
var OnboardingStageGenericCompletion = require("components/users/teachers/onboarding/OnboardingStageGenericCompletion");

var OnboardingStageSetAssignments = require("components/users/teachers/onboarding/OnboardingStageSetAssignments");
var OnboardingStageSelectFeatures = require("components/users/teachers/onboarding/OnboardingStageSelectFeatures");
var OnboardingStageSelectQuizFormat = require("components/users/teachers/onboarding/OnboardingStageSelectQuizFormat");
var OnboardingStageSetAssignments = require("components/users/teachers/onboarding/OnboardingStageSetAssignments");

var OnboardingStageCustomizeQuiz = require("components/users/teachers/onboarding/OnboardingStageCustomizeQuiz");
var OnboardingStageAutograderDemo = require("components/users/teachers/onboarding/OnboardingStageAutograderDemo");

require("users/teachers/onboarding_modal.scss");

class OnboardingModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		LuckyOrangeClient.tagComponent("OnboardingModal");
		this.state = {
			stageIndex: 0, persistentData: {}
		};
	}

	getCurrentTrack() {
		if (this.props.track == "quiz-customization") {
			if (Mycroft.isActiveVariation("onboarding-autograder-demo", "onboarding-modal")) {
				var quiz_customization_track = [...OnboardingModal.QUIZ_CUSTOMIZATION_TRACK]
				quiz_customization_track.splice(3, 0, OnboardingModal.AUTOGRADER_DEMO)
				return quiz_customization_track
			} else {
				return OnboardingModal.QUIZ_CUSTOMIZATION_TRACK;
			}
		} else {
			return OnboardingModal.CONTROL_TRACK;
		}
	}

	getStageCount() {
		return this.getCurrentTrack().length;
	}

	getCurrentStageData() {
		return this.getCurrentTrack()[this.state.stageIndex];
	}

	getStageTitle() {
		var currentStageData = this.getCurrentStageData();
		return currentStageData.title;
	}

	advanceStage(newPersistentData) {
		var newStageIndex = this.state.stageIndex + 1;

		if (newPersistentData) {
			var updatedPersistentData = _.extend({}, this.state.persistentData, newPersistentData);
		} else {
			var updatedPersistentData = this.state.persistentData;
		}
		this.setState({ stageIndex: newStageIndex, persistentData: updatedPersistentData }, function() {
			var currentStageData = this.getCurrentStageData();

			Mycroft.newEvent({ category: "Onboarding", action: "stage-started", value: currentStageData.name });

			if (currentStageData.isComplete) {
				// Mark onboarding complete
				var adminID = CurrentUser.get().id;
				var adminData = { pending_onboarding: false };
				CurrentUser.api().patchAdmin(adminID, { admin: adminData }, $wr.apiHandler((response) => {
				}));
			}
		}.bind(this));
	}

	endOnboarding(e) {
		$wr.nope(e)
		this.refs.modal.hide();
	}

	onModalClose() {
		$(window.document).trigger("expectations-updated");
	}

	logOut(e) {
		$wr.nope(e)
		CurrentUser.logOut();
		window.location = WhooosReadingServices.OuterPages.url("/");
	}

	render() {
		var currentStageData = this.getCurrentStageData();

		var logOutLink = (
			<a href="#" className="logOutLink" onClick={ this.logOut }>Log Out</a>
		);

		return (
			<Modal className="onboardingModal" preventHide={ this.state.stageIndex == 0 }
				onHide={ this.onModalClose } ref="modal">
		 		<a href="#" className="logOutLink" onClick={ this.logOut }>Log Out</a>
				<div className="onboardingProgressSection">
					<p className="onboardingTitle">{ this.getStageTitle() }</p>
					<ProgressBar current={ this.state.stageIndex } total={ this.getStageCount() - 1 } />
				</div>

				<currentStageData.component track={ this.props.track }
					persistentData={ this.state.persistentData }
					endOnboarding={ this.endOnboarding } onComplete={ this.advanceStage } />
			</Modal>
		);
	}

	componentDidMount() {
		this.refs.modal.show();
		Mycroft.newEvent({ category: "Onboarding", action: "track-started", value: this.props.track });
	}
}

OnboardingModal.propTypes = StrictPropTypes({
	track: PropTypes.string
});

// List of Tracks:
OnboardingModal.CONTROL_TRACK = [
	{
		name: "control-grade-level",
		title: "Hold your students accountable for reading",
		component: OnboardingStageGenericGradeLevel
	}, {
		name: "control-select-standards",
		title: "Hold your students accountable for reading",
		component: OnboardingStageSelectStandards
	}, {
		name: "control-completion",
		title: "Congratulations, you're all set!",
		component: OnboardingStageGenericCompletion,
		isComplete: true
}];

OnboardingModal.QUIZ_CUSTOMIZATION_TRACK = [
	{
		name: "control-grade-level",
		title: "Hold your students accountable for reading",
		component: OnboardingStageGenericGradeLevel
	},
	{
		name: "control-select-standards",
		title: "Hold your students accountable for reading",
		component: OnboardingStageSelectStandards
	}, 
	{
		name: "control-quiz-customization",
		title: "Set your expectations",
		component: OnboardingStageCustomizeQuiz
	},
	{
		name: "control-completion",
		title: "Congratulations, you're all set!",
		component: OnboardingStageGenericCompletion,
		isComplete: true
	}];

OnboardingModal.AUTOGRADER_DEMO = {
	name: "control-autograder-demo",
	title: "Try Our Autograder",
	component: OnboardingStageAutograderDemo
}

module.exports = OnboardingModal;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingModal.js